//import axios from "axios";
import { Locale } from "../frame/Locale.js";
import { Errata } from "./Errata.js";
export { Request };
const local = new Locale("Request");
/**
 * Запрос к микросервису, отслеживающий своё состояние для React.
 *
 * Создаётся с помощью хука `Service.useRequest`.
 * 
 * @summary Запрос к микросервису.
 * @see {@link Service.js}
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
class Request {
  // Создаётся с помощью хука Service.useRequest
  constructor(state) {
    this.state = state;
  }
  // Используется для внутреннего обновления состояния
  update(loading, response, errata) {
    this.state.loading = loading;
    this.state.response = response;
    this.state.errata = errata;
  }
  /** @returns {boolean} true, если запрос находится в процессе обработки. */
  isLoading() {
    return false !== this.state.loading;
  }
  /** @returns {boolean} true, если обработка запроса завершена с ошибкой. */
  hasError() {
    return !!this.state.errata;
  }
  /** @returns {boolean} true, если обработка запроса успешно завершена. */
  isReady() {
    return !this.isLoading() && !this.hasError() && !!this.state.response;
  }
  /** @returns {Object} Данные полученные от сервера. */
  getResponse() {
    if (!this.state.response)
      throw local.invalid("getResponse@state", this.state);
    return this.state.response;
  }
  /** @returns {Errata} Отчёт об ошибке. errata */
  getErrata() {
    if (!this.state.errata)
      throw local.invalid("getErrata@state", this.state);
    return new Errata(this.state.errata || {});
  }
}
